export enum PaperBagsWithHandlesLabels {
  type = "type",
  dimensions = "dimensions",
  color = "color",
  print = "print",
}
